/* xlsx.js (C) 2013-present  SheetJS -- http://sheetjs.com */
/* Notes:
   - usage: `ReactDOM.render( <SheetJSApp />, document.getElementById('app') );`
   - xlsx.full.min.js is loaded in the head of the HTML page
   - this script should be referenced with type="text/babel"
   - babel.js in-browser transpiler should be loaded before this script
*/
import React from "react";

import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Table,
  Tr,
  Td,
  Tbody,
  Th,
  Thead,
} from "@chakra-ui/react";

import * as XLSX from "xlsx/xlsx.mjs";
import { objMagicTable } from "../../objs";

class SheetJSApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [] /* Array of Arrays e.g. [["a","b"],[1,2]] */,
      cols: [] /* Array of column objects e.g. { name: "C", K: 2 } */,
    };
    this.handleFile = this.handleFile.bind(this);
    this.exportFile = this.exportFile.bind(this);
  }
  handleFile(file /*:File*/) {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      console.log(rABS, wb);
      /* Convert array of arrays */
      //const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const data = XLSX.utils.sheet_to_json(ws, { header: 1, defval: null });
      /*const dataCsv = XLSX.utils.sheet_to_csv(ws);
      var lst = dataCsv.split("\n");
      for (var f in lst) {
        if (lst[f].includes(",")) {
          var row = lst[f].split(",");
          console.log(row.length);
        }
      }*/
      //console.log(dataCsv);
      //console.log(data);
      /* Update state */

      this.setState({ data: data, cols: make_cols(ws["!ref"]) });
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  }
  exportFile() {
    /* convert state to workbook */
    const ws = XLSX.utils.aoa_to_sheet(this.state.data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, "sheetjs.xlsx");
  }

  btnProcess() {
    const { data, cols } = this.state;
    console.log(cols);
    console.log(data);
  }

  render() {
    const { data, cols } = this.state;

    var objShowTbl = new objMagicTable([], [], []);

    var lstTitles = data[0];
    var lstData = [];
    for (var i = 1; i < data.length - 1; i++) {
      lstData.push(data[i]);
    }

    var showTbl = objShowTbl.getChakraTbl(lstTitles, lstData);

    return (
      <Box w="100%">
        <Stack w="100%">
          <DragDropFile handleFile={this.handleFile}>
            <div>
              <div>
                <DataInput handleFile={this.handleFile} />
              </div>
            </div>
            <div>
              <div>
                <button
                  disabled={!this.state.data.length}
                  onClick={this.exportFile}
                >
                  Export
                </button>
              </div>
            </div>
            <div>
              <div></div>
            </div>
          </DragDropFile>
          <button
            disabled={!this.state.data.length}
            onClick={() => this.btnProcess()}
          >
            Process
          </button>
          {showTbl}
        </Stack>
      </Box>
    );
  }
}

//<OutTable data={this.state.data} cols={this.state.cols} />

export default SheetJSApp;

/* -------------------------------------------------------------------------- */

/*
  Simple HTML5 file drag-and-drop wrapper
  usage: <DragDropFile handleFile={handleFile}>...</DragDropFile>
    handleFile(file:File):void;
*/
class DragDropFile extends React.Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
  }
  suppress(evt) {
    evt.stopPropagation();
    evt.preventDefault();
  }
  onDrop(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    const files = evt.dataTransfer.files;
    if (files && files[0]) this.props.handleFile(files[0]);
  }
  render() {
    return (
      <div
        onDrop={this.onDrop}
        onDragEnter={this.suppress}
        onDragOver={this.suppress}
      >
        {this.props.children}
      </div>
    );
  }
}

/*
  Simple HTML5 file input wrapper
  usage: <DataInput handleFile={callback} />
    handleFile(file:File):void;
*/
class DataInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const files = e.target.files;
    if (files && files[0]) this.props.handleFile(files[0]);
  }
  render() {
    return (
      <form className="form-inline">
        <div className="form-group">
          <label htmlFor="file">Spreadsheet</label>
          <input
            type="file"
            className="form-control"
            id="file"
            accept={SheetJSFT}
            onChange={this.handleChange}
          />
        </div>
      </form>
    );
  }
}

/*
  Simple HTML Table
  usage: <OutTable data={data} cols={cols} />
    data:Array<Array<any> >;
    cols:Array<{name:string, key:number|string}>;
*/
class OutTable extends React.Component {
  state = {
    data: [],
    cols: [],
  };
  componentDidMount() {
    this.setState({ data: this.props.data, cols: this.props.cols });
  }

  btnProcess() {
    const { data, cols } = this.state;
    console.log(cols);
    console.log(data);
  }

  render() {
    const { data, cols } = this.state;
    return (
      <div>
        <button
          disabled={!this.state.data.length}
          className="btn btn-success"
          onClick={() => this.btnProcess()}
        >
          Process
        </button>
        <div>
          <table>
            <thead>
              <tr>
                {cols.map((c) => (
                  <th key={c.key}>{c.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((r, i) => (
                <tr key={i}>
                  {cols.map((c) => (
                    <td key={c.key}>{r[c.key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

/* list of supported file types */
const SheetJSFT = [
  "xlsx",
  "xlsb",
  "xlsm",
  "xls",
  "xml",
  "csv",
  "txt",
  "ods",
  "fods",
  "uos",
  "sylk",
  "dif",
  "dbf",
  "prn",
  "qpw",
  "123",
  "wb*",
  "wq*",
  "html",
  "htm",
]
  .map(function (x) {
    return "." + x;
  })
  .join(",");

/* generate an array of column objects */
const make_cols = (refstr) => {
  let o = [],
    C = XLSX.utils.decode_range(refstr).e.c + 1;
  for (var i = 0; i < C; ++i) o[i] = { name: XLSX.utils.encode_col(i), key: i };
  return o;
};
